module.exports = __webpack_public_path__ + "img/CA.a4122561.png";